<template>
	<div id="VRmap" style="width: 1200px;
		margin: 0 auto;">
		<div style="position: fixed;bottom: 5px;right: 50px;width: 50px;height: 50px;background-color: red;color: #FFF;z-index: 2;line-height: 50px;text-align: center;" @click="fha">
				  返回
		</div>
		<!-- 头标签 -->
		<dpubtop></dpubtop>
		
		<div style="width: 100%;height: 1000px;">
			<mapss></mapss>
		</div>
		
		<!-- 尾标签 -->
		<myfooter></myfooter>
	</div>
</template>

<script>
	export default {
		data(){
			return{
				
			}
		},
		methods:{
			fha(){
				console.log('返回上一层')
				this.$router.go(-1);//返回上一层
			},
		},
		components: {
			// 尾标签,
			myfooter: resolve => require(['@/components/myfooter'], resolve),
			// 头标签
			dpubtop: resolve => require(['@/components/dpubtop/dpubtop'], resolve),
			//测标签
			rightlist: resolve => require(['@/components/dpubtop/rightList.vue'], resolve),
			//广澳
			PCguangao: resolve => require(['@/components/dpubtop/PCguangao.vue'], resolve),
			//相关阅读
			Xguanyuedu: resolve => require(['@/components/dpubtop/xgyd.vue'], resolve),
			//地图
			mapss: resolve => require(['@/components/mapss'], resolve),
		}
	}
</script>

<style>
</style>